import { getShips, groupBy, } from "../../shared/models/api";
import Loader from "@phoenixreisen/reacts/src/loader";
import React, { useEffect, useState } from "react";
import Model from "../../shared/models/model";
import de from "date-and-time/locale/de";
import { Link } from "react-router-dom";
import dt from "date-and-time";
dt.locale(de);
export const List = (props) => {
    const { schedules } = props;
    const [category, setCategory] = useState("datum");
    const [grouped, setGrouped] = useState(null);
    const reorder = (cat, e) => {
        e.preventDefault();
        setGrouped(null);
        setTimeout(() => {
            setCategory(cat);
            setGrouped(groupBy(cat, schedules));
        }, 200);
    };
    useEffect(() => {
        if (schedules) {
            setGrouped(groupBy(category, schedules));
        }
    }, [schedules, category]);
    if (!schedules || !grouped) {
        return React.createElement(Loader, null);
    }
    if (!getShips(schedules, "alle").length) {
        return (React.createElement("section", { className: "schedules list empty" },
            React.createElement("p", { className: "alert alert--info alert--icon" },
                React.createElement("i", { className: "fas fa-info-circle" }),
                "Zurzeit werden keine Termine angeboten.")));
    }
    return (React.createElement("section", { className: "schedules" },
        React.createElement("h3", null,
            "Termine (",
            schedules.length,
            ")"),
        React.createElement("p", null,
            "Sortieren nach:",
            React.createElement(Link, { to: "/", onClick: (e) => reorder("datum", e), className: "mh2" },
                React.createElement("i", { className: "fas fa-sort" }),
                " Datum"),
            React.createElement(Link, { to: "/", onClick: (e) => reorder("schiff", e), className: "mh2" },
                React.createElement("i", { className: "fas fa-sort" }),
                " Schiff"),
            React.createElement(Link, { to: "/", onClick: (e) => reorder("hafen", e), className: "mh2" },
                React.createElement("i", { className: "fas fa-sort" }),
                " Hafen")),
        schedules.length === 0 && (React.createElement("section", { className: "schedules list empty" },
            React.createElement("p", { className: "alert alert--info alert--icon" },
                React.createElement("i", { className: "fas fa-info-circle" }),
                "F\u00FCr diese Auswahl werden leider keine Termine angeboten."))),
        schedules.length > 0 && (React.createElement("section", { className: "schdedules list" }, Object.keys(grouped).map((item, i) => {
            return (React.createElement("article", { key: `${item}-${i}`, className: "sub-list" },
                React.createElement("div", { className: "headline" },
                    React.createElement("i", { className: "fas fa-ship mr2" }),
                    dt.isValid(item, "YYYY-MM-DD")
                        ? dt.format(dt.parse(item, "YYYY-MM-DD"), "dd, DD.MM.YYYY")
                        : item),
                React.createElement("div", { className: "items" }, grouped[item].map((sched, p) => {
                    const isLast = p === grouped[item].length - 1;
                    const date = dt.format(dt.parse(sched.datum, "YYYY-MM-DD"), "dd, DD.MM.YYYY");
                    return (React.createElement(Link, { className: `item ${isLast ? "last" : ""}`, key: `${item}-${p}`, onClick: () => (Model.schedule = sched), to: "/kunde" },
                        React.createElement("div", { className: "flex justify-between" },
                            category === "datum" && (React.createElement("div", { className: "item-value" },
                                sched.schiff.name,
                                " - ",
                                sched.hafen)),
                            category === "schiff" && (React.createElement("div", { className: "item-value" },
                                sched.schiff.name,
                                " - ",
                                date,
                                " - ",
                                sched.hafen)),
                            category === "hafen" && (React.createElement("div", { className: "item-value" },
                                sched.schiff.name,
                                " - ",
                                date,
                                " - ",
                                sched.hafen)),
                            React.createElement("div", { className: "item-link tr" },
                                React.createElement("i", { className: "fas fa-arrow-right" })))));
                }))));
        })))));
};
export default List;
